import { render } from "./InvitationRequestModal.vue?vue&type=template&id=e8a81144&scoped=true&ts=true"
import script from "./InvitationRequestModal.vue?vue&type=script&lang=ts"
export * from "./InvitationRequestModal.vue?vue&type=script&lang=ts"

import "./InvitationRequestModal.vue?vue&type=style&index=0&id=e8a81144&lang=scss&scoped=true"

import exportComponent from "/opt/booza-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8a81144"]])

export default __exports__